import { INPUT_SIZES } from 'cdk-radial';
import { useState, ChangeEvent, useEffect, useCallback } from 'react';
import { useIntl, IntlShape } from 'react-intl';
import { InputSizes } from 'components/CashInBankAccountsDropdown/types';
import { getSelectedCIBAccount } from 'pages/VendorsTablePage/components/PrintChecks/slice';
import { useAppSelector } from 'store/hooks';
import { messages } from './messages';
import { StyledPostingDesc } from './styled';
import { PostingDescriptionType } from './types';

export const PostingDescription = ({
  handlePostingDescription,
  postingDescription
}: PostingDescriptionType): React.JSX.Element => {
  const [hasPostingDescError, setPostingDescError] = useState<boolean>(false);
  const [isRequired, setIsRequired] = useState<boolean>(false);
  const intl: IntlShape = useIntl();
  const { postingDescriptionRequired } = useAppSelector(getSelectedCIBAccount);

  const validateDesc = useCallback(
    (desc: string) => {
      const isInValid = isRequired && desc === '';
      setPostingDescError(isInValid);
      return !isInValid;
    },
    [setPostingDescError, isRequired]
  );

  const handlePostingDesChange = (event: ChangeEvent<HTMLInputElement>) => {
    handlePostingDescription(event.target?.value);
    validateDesc(event.target?.value);
  };
  useEffect(() => {
    validateDesc('');
  }, [validateDesc]);

  useEffect(() => {
    if (postingDescriptionRequired) setIsRequired(postingDescriptionRequired);
  }, [postingDescriptionRequired, setIsRequired]);

  const { SMALL } = INPUT_SIZES as InputSizes;
  return (
    <>
      <StyledPostingDesc
        data-testid="postingDescription"
        isRequired={isRequired}
        label={intl.formatMessage(messages.postingDescription)}
        name="input-error"
        onChange={handlePostingDesChange}
        value={postingDescription}
        errorMessage={intl.formatMessage(
          messages.postingDescriptionErrorMessage
        )}
        hasError={hasPostingDescError}
        enableCustomValidation
        size={SMALL}
      />
    </>
  );
};
